import React, { useEffect, useRef, useState } from "react";
import "./Work.css";
import { useCountry } from "../utility/utility";

const stats = [
  { target: 35,  suffix: "K+", label: "CHATBOTS DEPLOYED" },
  { target: 28,  suffix: "K+", label: "APPS BUILT" },
  { target: 75,   suffix: "K+", label: "NFC TAPS EVERY MONTH" },
  { target: 15,  suffix: "K+", label: "CORPORATE PARTNERS" },
];

const dubaiTestimonials = [
  {
    stars: 5,
    text: "We were relying on Instagram and WhatsApp for most of our orders, which became difficult to manage. After using BusinessBay, everything is finally in one place. The dashboard makes it much easier to track customers and orders.",
    name: "Omar Al-Mansoori",
    role: "Restaurant Owner · Dubai",
    initials: "O",
    color: "#E87040",
  },
  {
    stars: 5,
    text: "The NFC card surprised me. Instead of giving paper cards that people lose, I just tap, and they instantly save my contact. It’s simple, but it works really well for networking events here in Dubai.",
    name: "Fatima Khalid Al-Nuaimi",
    role: "Real Estate Consultant · Dubai",
    initials: "F",
    color: "#3AAFA9",
  },
  {
    stars: 5,
    text: "Customer messages used to pile up when the clinic got busy. The AI chatbot now handles common questions and appointment details. It saves us a lot of time during the day.",
    name: "Dr. Sameer Hassan Al-Rashid",
    role: "Clinic Owner · Dubai",
    initials: "S",
    color: "#7C5CBF",
  },
];
const indiaTestimonials = [
  {
    stars: 5,
    text: "Running a small restaurant means handling orders, customers, and delivery all at once. BusinessBay helped us set up our own ordering system without paying big commissions.",
    name: "Rahul Sharma",
    role: "Restaurant Owner · Delhi",
    initials: "R",
    color: "#E87040",
  },
  {
    stars: 5,
    text: "I’m not very technical, so I liked how easy the platform is. Within a day we had our business profile and chatbot working. Customers now get replies instantly.",
    name: "Priya Mehta",
    role: "Boutique Owner · Jaipur",
    initials: "P",
    color: "#3AAFA9",
  },
  {
    stars: 5,
    text: "Earlier we were using different apps for leads and customer communication. BusinessBay brought everything together. Now I can see leads, messages, and performance in one dashboard.",
    name: "Arjun Patel",
    role: "Property Consultant · Bangalore",
    initials: "A",
    color: "#7C5CBF",
  },
];

function useCountUp(target, duration = 2000, decimal = false) {
  const [count, setCount] = useState(decimal ? "0.0" : 0);
  const raf = useRef(null);

  useEffect(() => {
    const start = performance.now();
    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = eased * target;
      setCount(decimal ? current.toFixed(1) : Math.floor(current));
      if (progress < 1) {
        raf.current = requestAnimationFrame(step);
      } else {
        setCount(decimal ? target.toFixed(1) : target);
      }
    };
    raf.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf.current);
  }, [target, duration, decimal]);

  return count;
}

function StatCard({ stat }) {
  const count = useCountUp(stat.target, 2000, stat.decimal);
  return (
    <div className="stat-card">
      <span className="stat-value">{count}{stat.suffix}</span>
      <span className="stat-label">{stat.label}</span>
    </div>
  );
}

const StarRating = ({ count }) => (
  <div className="stars">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="star">★</span>
    ))}
  </div>
);

export default function Work() {
  const {countryCode} = useCountry();
  return (
    <section className="testimonials-section mainclass">
    <div className="maxwidth">
        <div className="section-header">
        <p className="proof-label">See The Impact</p>
        <h2 className="section-title heading">
          Real results from <br/>real businesses worldwide.
        </h2>
      </div>

      <div className="stats-grid">
        {stats.map((stat, i) => (
          <StatCard stat={stat} key={i} />
        ))}
      </div>

      <div className="testimonials-grid">
        {(countryCode == "ae " ? dubaiTestimonials : indiaTestimonials)?.map((t, i) => (
          <div key={i} className="testimonial-card">
            {/* <span className="quote-mark">"</span> */}
            <StarRating count={t.stars} />
            <p className="testimonial-text">{t.text}</p>
            <div className="testimonial-author">
              <div
                className="author-avatar"
                style={{ backgroundColor: t.color }}
              >
                {t.initials}
              </div>
              <div className="author-info">
                <span className="author-name">{t.name}</span>
                <span className="author-role">{t.role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
}